<template>
  <div class="depositStatusListen">
    <div class="listen">
      <div class="title">
        <span>{{ $t('lang.account.listen') }}</span>
        <div class="liveChat" @click="handleOpenChat"><img :src="liveChat" alt=""/></div>
      </div>
      <div class="center">
        <div class="desc" v-for="(item,index) in $t('lang.account.oneMoreTry')" :key="index">{{ item }}</div>
      </div>
      <div class="buttons">
        <div class="btn1" @click="gotoRoute('Deposit')">{{ $t('lang.account.newOrder') }}</div>
        <div class="btn2" @click="handleClose">{{ $t('lang.inviteFriends.close') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import liveChat from '@/assets/images/Account/liveChat.svg'
import {LogUtils, closePop} from '@/utils'
export default {
  name: 'DepositStatusListen',
  props: ['handleClose', 'userInfo'],
  data () {
    return {
      liveChat
    }
  },
  mounted () {
    if (this.userInfo) {
      LogUtils.saveUserEvent('DepositMonitoring7', this.userInfo.UserId)
    }
  },
  methods: {
    handleOpenChat () {
      if (this.userInfo) {
        LogUtils.saveUserEvent('DepositMonitoring10', this.userInfo.UserId)
      }
      if (this.userInfo && this.userInfo.UserShowId) {
        window.LiveChatWidget.call('set_customer_name', this.userInfo.UserShowId)
      } else {
        window.LiveChatWidget.call('set_customer_name', ' ')
      }
      window.LiveChatWidget.call('maximize')
    },
    gotoRoute (label) {
      if (this.userInfo) {
        LogUtils.saveUserEvent('DepositMonitoring8', this.userInfo.UserId)
      }
      this.$router.push('/' + label)
      closePop(12)
    }
  }
}
</script>

<style lang="less" scoped>
.depositStatusListen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 200;

  .listen {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 86.666vw;
    height: 76.666vw;
    background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%);
    border: 0.3vw solid #737373;
    border-radius: 4.166vw;

    .title {
      position: relative;
      margin-top: 4.722vw;
      font-size: 5.833vw;
      font-weight: 700;
      text-align: center;
      color: #FFFFFF;
      height: 8.3333vw;
      display: flex;
      justify-content: center;
      align-items: flex-end;

      .liveChat {
        position: absolute;
        top: 0;
        right: 6vw;
        width: 8.3333vw;
        height: 8.3333vw;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .center {
      margin-top: 6vw;

      .desc {
        margin-top: 1vw;
        font-size: 4.722vw;
        font-weight: 400;
        text-align: center;
        color: #C4C4C4;
      }
    }
    .buttons {
      margin: 12vw auto;
      width: 65.883vw;
      height: max-content;
      text-align: center;
      line-height: 10vw;
      text-transform: capitalize;
      font-size: 4.166vw;
      font-weight: 600;

      .btn1 {
        width: 65.883vw;
        border-radius: 1.388vw;
        height: 10vw;
        background: linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
        color: #000000;
      }

      .btn2 {
        margin-top: 3.333vw;
        width: 65.883vw;
        border-radius: 1.388vw;
        height: 10vw;
        border: 0.3vw solid #E2C28F;
        color: #E1C18D;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DepositStatusListen/index.vue